import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class ObraNavegacaoService {

  private _obraIds: number[] = [];
  private _moduloRota: string = '';
  private _moduloPorObraId: Record<number, string> = {};

  setObraIds(
    ids: number[],
    moduloRota: string,
    moduloPorObraId?: Record<number, string>,
  ): void {
    this._obraIds        = [...ids];
    this._moduloRota      = moduloRota;
    this._moduloPorObraId = moduloPorObraId ? { ...moduloPorObraId } : {};
  }

  getObraIds(): number[] {
    return this._obraIds;
  }

  getModuloRota(workID?: number): string {
    if (workID != null && this._moduloPorObraId[workID]) {
      return this._moduloPorObraId[workID];
    }
    return this._moduloRota;
  }

  getIndice(workID: number): number {
    return this._obraIds.indexOf(workID);
  }

  getAnterior(workID: number): number | null {
    const idx = this.getIndice(workID);
    return idx > 0 ? this._obraIds[idx - 1] : null;
  }

  getProximo(workID: number): number | null {
    const idx = this.getIndice(workID);
    return idx >= 0 && idx < this._obraIds.length - 1
      ? this._obraIds[idx + 1]
      : null;
  }

  temNavegacao(): boolean {
    return this._obraIds.length > 1;
  }
}